import annualAwardsManager from "../../../api/AnnualAwardsManager";

const calculateBestTime = (day: string, month: string, year: string, timeGame: number) => {
  const games = annualAwardsManager.loadMonthGames(year, month);
  const timeGameCompleted = games.find((game) => game.day === day);
  return timeGameCompleted ? Math.min(timeGameCompleted.timeSec, timeGame) : timeGame;
};

export default calculateBestTime;
